import { NativeModules } from 'react-native';
const MyTracker = NativeModules.MyTracker;
export default MyTracker;
//# sourceMappingURL=index.js.map